import { CircleAlert, Info } from 'lucide-react';

import { cn } from '../lib/cn';

import type { ReactNode } from 'react';

export function Alert({
  tone = 'danger',
  children,
}: {
  tone?: 'danger' | 'info';
  children: ReactNode;
}) {
  return (
    <div
      role={tone === 'danger' ? 'alert' : 'status'}
      className={cn(
        'flex items-start gap-2.5 rounded-lg border px-4 py-3 text-sm leading-6',
        tone === 'danger'
          ? 'bg-danger-soft text-danger border-danger/30'
          : 'bg-accent-soft text-accent border-accent-line',
      )}
    >
      {tone === 'danger' ? (
        <CircleAlert className="mt-1 size-4 shrink-0" aria-hidden="true" />
      ) : (
        <Info className="mt-1 size-4 shrink-0" aria-hidden="true" />
      )}
      <div className="min-w-0">{children}</div>
    </div>
  );
}
